import styled from "styled-components";

interface IContainerProps {
  small: boolean;
  criare?: boolean;
  italinea?: boolean;
  selected?: boolean;
  disableOnFocus?: boolean;
  todeschini?: boolean;
  animationTrigger?: boolean;
}

export const Container = styled.button<IContainerProps>`
  width: ${(props) => (props.small ? 15.6 : 22.4)}rem;
  height: ${(props) => (props.small ? 15.5 : 14.2)}rem;
  background: ${(props) =>
    props.selected
      ? "rgba(0, 0, 0, 0.2)"
      : props.italinea
      ? "inherit"
      : props.criare
      ? "unset"
      : "#efefef"};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  margin-right: ${(props) => (props.small ? 2.6 : 1.3)}rem;
  margin-bottom: ${(props) => (props.small ? 2.6 : 1.3)}rem;
  box-shadow: ${(props) =>
    props.criare ? "rgba(0, 0, 0, 0.35) 0px 5px 15px" : "unset"};
  border: ${(props) => (props.italinea ? "3px solid #153C8B" : "unset")};
  border-radius: ${(props) => (props.italinea ? "1.4rem" : "unset")};
  padding: 0.2rem;
  color: ${(props) => (props.selected ? "white" : "unset")};

  @media (max-width: 1200px) {
    width: 48%;
    margin: 0;
  }

  &:focus {
    /* background: #565656; */
    background: ${(props) =>
      props.disableOnFocus ? "unset" : "rgba(0, 0, 0, 0.2)"};
    color: ${(props) => (props.disableOnFocus ? "unset" : "white")};
  }

  span {
    font-family: "Galano";
    font-weight: ${(props) => (props.criare ? 800 : 600)};
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: ${(props) => (props.criare ? "#000000" : "#696969")};
    text-align: center;
    width: ${(props) => (props.small ? 80 : 100)}%;
  }

  img {
    max-width: 100%;
  }
`;
